import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import Styles from "./styles.scss";

class FilterToggle extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            selected: props.selected
        };
    }

    handleClick = (e) => {
        const { id } = e.target;
        this.setState({ selected: id });
        this.props.handleChange(id);
    };

    render() {
        const { options, classes, dataTestId = "filter-toggle" } = this.props;
        const { selected } = this.state;
        if (!options) {
            return null;
        }

        return (
            <>
                <style jsx>{Styles}</style>
                <div className="filter__toggle" data-testid={dataTestId}>
                    {options.map((id) => (
                        <button
                            type="button"
                            onClick={this.handleClick}
                            id={id}
                            className={`${classes} ${
                                selected === id ? "filter__toggle--selected" : ""
                            }`}
                            key={id}
                        >
                            {id}
                        </button>
                    ))}
                </div>
            </>
        );
    }
}

FilterToggle.propTypes = {
    handleChange: PropTypes.func.isRequired,
    selected: PropTypes.string.isRequired,
    options: PropTypes.arrayOf(PropTypes.string).isRequired,
    classes: PropTypes.string
};

FilterToggle.defaultProps = {
    classes: ""
};
export default FilterToggle;
